import { render } from "./UserWorkspaceAttributes.vue?vue&type=template&id=56a6e12c"
import script from "./UserWorkspaceAttributes.vue?vue&type=script&lang=js"
export * from "./UserWorkspaceAttributes.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__